import { z } from 'zod';
import { id } from '../atomic/id';
import { url } from '../atomic/url';
import { date } from '../atomic/date';
import { contractSchema } from './contract';

export const attachmentSchema = z.object({
  id,
  url,
  name: z.string(),
  createdAt: date,
  serviceId: id,
  contract: contractSchema,
  type: z.string(),
});
